import { Calendar } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useYear } from "@/contexts/YearContext";

export const YearSelector = () => {
  const { selectedYear, setSelectedYear, availableYears } = useYear();

  return (
    <Select value={String(selectedYear)} onValueChange={(v) => setSelectedYear(parseInt(v, 10))}>
      <SelectTrigger className="h-9 w-[110px] gap-1">
        <Calendar className="h-4 w-4 text-muted-foreground" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {availableYears.map((y) => (
          <SelectItem key={y} value={String(y)}>
            Year {y}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};